// extracted by mini-css-extract-plugin
export default {"Container":"GameCardItem_Container__q1vdj","Body":"GameCardItem_Body__0enpW"};